import React, { useState, useRef, useEffect } from "react";
import { useUserContext } from "../../context/UserContext";
import { Panel, NimbusLink as Link } from "tds_shared_ui";
import { NotificationList } from "./NotificationList";
import "./NotificationIcon.css";
import PropTypes from "prop-types";

export const NotificationIcon = ({
  className,
  onHide,
}) => {
  const node = useRef(null);
  const [markAsRead, setMarkAsRead] = useState(false);
  const { notificationData, displayNotification, setNotificationDisplay } = useUserContext();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (displayNotification) {
        const currentNode = node.current;
        if (!currentNode || !currentNode.contains(event.target)) {
          hide();
        }
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [displayNotification]);

  const hide = () => {
    onHide();
  };

  const handleMarkAsReadClick = () => {
    setMarkAsRead(true);
  };

  const togglePanel = () => {
    setNotificationDisplay(!displayNotification);
  };

  const displayClass = (
    "cart-container " + (className || "")
  ).trim();
  return (
    <div className={displayClass} ref={node}>
      <Link href="#" onClick={togglePanel}>
        <div>
          <i className={"fas fa-bell"}></i>
          {notificationData.length > 0 &&
            markAsRead === false && (
              <span className="badge badge-danger rounded-circle">
                {notificationData.length}
              </span>
            )}
        </div>
      </Link>
      <Panel
        floating={true}
        hidden={!displayNotification}
        className="cart-panel"
      >
        <NotificationList
          onClick={handleMarkAsReadClick}
          markAsRead={markAsRead}
        />
      </Panel>
    </div>
  );
};

NotificationIcon.propTypes = {
  className: PropTypes.string,
  onHide: PropTypes.func.isRequired,
};